import { Component, Prop, Method, h, Element } from '@stencil/core';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * SignNow Cookie banner component
 * Extends cookie-type-1 with a cookie icon image shown on desktop
 *
 * @product signnow
 * @version 1.0.0
 * @category SignNow
 * @constant COOKIE_BANNER_DESCRIPTION - "We use cookies to improve security, personalize the user experience, enhance our marketing activities (including cooperating with our 3rd party partners) and for other business use. Click <a href=\"/cookies\" title=\"Cookie Policy\">here</a> to&nbsp;read our Cookie Policy. By&nbsp;clicking \"Accept\" you agree to&nbsp;the use of&nbsp;cookies." - HTML content for cookie description
 * @constant COOKIE_BANNER_ACCEPT - Accept - Text for Accept button
 * @constant COOKIE_BANNER_READ_MORE - "Read more" - Text for "Read more" link
 * @constant COOKIE_BANNER_READ_LESS - "Read less" - Text for "Read less" link
 */
@Component({
  tag: 'sn-cookie-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNcookieType1 {
  @Element() el: HTMLElement;

  /**
   * Component constants object containing all required text constants
   */
  @Prop({ mutable: true }) constants?: Record<string, string> | string;

  /**
   * Delay before showing the cookie popup in milliseconds
   * @default 4000
   */
  @Prop() delay: number = 4000;

  /**
   * Label for close button (for accessibility)
   */
  @Prop() closeLabel: string = 'Close cookie popup';

  componentWillLoad() {
    this.constants = parseJsonProp(this.constants);
  }

  /**
   * Public method to open the cookie popup programmatically
   */
  @Method()
  async open(): Promise<void> {
    const base = this.el.querySelector('cookie-type-1') as any;
    if (base && typeof base.open === 'function') {
      await base.open();
    }
  }

  render() {
    return (
      <cookie-type-1
        constants={this.constants as Record<string, string>}
        delay={this.delay}
        closeLabel={this.closeLabel}
      ></cookie-type-1>
    );
  }
}
